module.exports = __webpack_public_path__ + "img/0_8664ec849.png";